const e = {
  src: {
    type: String,
    default: ""
  },
  fit: {
    type: String,
    default: ""
  }
  //   bodyStyle: {
  //     type: Object as PropType<StyleValue>([String, Object, Array]),
  //   default: '',
  // },
}, n = {
  load: (t) => t instanceof Event,
  error: (t) => t instanceof Event
};
export {
  n as imageEmits,
  e as imageProps
};
